export const Getters = {
  geek: {
    filtered: 'GET_FILTERED',
    groupedAdmins: 'GET_GROUPED_ADMINS',
  },
  activities: {
    grouped: 'GET_GROUPED',
  },
  opportunities: {
    filteredCandidates: 'GET_FILTERED_CANDIDATES',
  },
  achievements: {
    filtered: 'GET_FILETRED_ACHIEVEMENTS',
  },
};
